export default __webpack_public_path__ + "static/Healthcare-001fc15fa6e0c62a911ebcb5a88504de.webp";